import { createFileRoute } from "@tanstack/react-router";

import { requireSelling } from "@/features/shop/modules/offer-shell/require-selling";
import { ShopOrders } from "@/features/shop/modules/shop-orders/shop-orders";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/offer/orders/")({
  beforeLoad: requireSelling,
  loader: () => ({ crumb: m.shop_tab_orders() }),
  component: ShopOrders,
});
